import React, { useEffect, useRef, useState } from 'react'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Col, Form, Row, Tab, Tabs } from 'react-bootstrap'
import { CallApi, CommonModal } from '../../../Components/common/CommonFunctions'
import { toast } from 'react-toastify'
import { ReactComponent as Trash } from '../../../assets/images/icon_svg/delete.svg';  
import { ReactComponent as Edit_icon } from '../../../assets/images/icon_svg/edit.svg';  
import { ReactComponent as Save_icon } from '../../../assets/images/icon_svg/active.svg';  

const General = () => {

    const isMounted = useRef(false);
    const [isEditable, setIsEditable] = useState(null);
    const defaultShift = { button: 'Add' }
    const [shiftData, setShiftData] = useState([defaultShift]);
    const [formData, setFormData] = useState({});

    const fetchShift = () => {
        CallApi({
            endPoint: 'shift-report/get-org-shifts',
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    const updateData = innerData.length ? innerData.map(item => ({
                        ...item,
                        start_time: item.start_time.substring(0, 5),
                        end_time: item.end_time.substring(0, 5),
                        button: 'Edit'
                    })) : []
                    // const updateData = res.data.response_data.length ? res.data.response_data.map(item => ({ ...item, button: 'Edit' })) : [];
                    setShiftData(innerData.length ? [...updateData, defaultShift] : [defaultShift])
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    useEffect(() => {
        if (isMounted.current) return;
        fetchShift();
        isMounted.current = true;
    }, []);

    const addEditShift = (shft = null, idx) => {
        setIsEditable(idx)
        if (shft.button === 'Add') {
            const updatedShft = shiftData.filter(sh => sh.id);
            setShiftData([...updatedShft, { start_time: '', end_time: '', button: 'Save' }])
        } else if (shft.button === 'Edit') {
            // const trimData = shiftData.slice(0, -1)
            const trimData = shiftData.filter((sec) => sec.button !== 'Add');
            const updateData = trimData.map((sec, index) => {
                if (sec.id === shft.id) {
                    sec.button = 'Save'
                } else {
                    sec.button = 'Edit'
                }
                return sec;
            })
            setShiftData(updateData)
        } else if (shft.button === 'Save') {
            const { button, ...rest } = shft;
            saveSettings({ ...rest, status: 1 })
        }
    }
    const removeShift = (shft = null, idx) => {
        if (shft.id) {
            // setShiftData([{start_time: '', end_time: '', button: 'Save'}])
            saveSettings({ ...shft, status: 0 })
        } else {
            const updatedShft = shiftData.filter((sh, index) => index !== idx);
            setShiftData([...updatedShft, defaultShift])
        }
    }
    const shiftChange = (idx, name, val) => {
        // setFormData(prev => ({...prev, [name]: val}))
        setShiftData(prev =>
            prev.map((shft, index) =>
                index === idx ?
                    { ...shft, [name]: val }
                    : shft
            )
        )
        // setFormData(prev =>
        //     prev.map((shft, index) =>
        //         index === idx ?
        //             { ...shft, [name]: val }
        //             : shft
        //     )
        // )
    }
    const saveSettings = (shft) => {
        CallApi({
            endPoint: 'shift-report/save-org-shift-setting',
            payload: shft,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    // setIsEditable(false);
                    // const innerData = res.data.response_data;
                    // const updateData = {
                    //     ...innerData,
                    //     start_time: innerData.start_time.substring(0, 5),
                    //     end_time: innerData.end_time.substring(0, 5),
                    //     button: 'Edit'
                    // }
                    // setShiftData(prev => ([...prev, updateData, defaultShift]))
                    toast.success(res.data.response_msg)
                    setIsEditable(null)
                    fetchShift()
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });

    }

    return (
        <>
            <div className='d-flex justify-content-between align-items-center'>
                <div>
                    <h4>General Settings</h4>
                    <p>Manage and customize Shift configurations</p>
                </div>
                {/* <div>
                    <Button variant="primary" className='create_btn' onClick={modalOpen}>
                        <FontAwesomeIcon icon={faPlus} /> Create Report
                    </Button>
                </div> */}
            </div>
            <hr />
            {/* <Tabs id="warehouse-tabs" activeKey={activeshift} onSelect={handleShiftClick} className="booking_tab">
                {shifts?.map(st => (
                    <Tab eventKey={st.value} key={st.value} title={<span>{st.label}</span>} />
                ))}
            </Tabs> */}
            {console.log('FD', formData)}
            {console.log('SD', shiftData)}
            <div className='d-flex gap-3 flex-wrap'>
                <div className="stck_middle tw-35">
                    <div className='uld_notification'>
                        <div className="uld_notification_title">
                            <Row className='align-items-center'>
                                <Col sm="6">
                                    <h3>Shift List</h3>
                                </Col>
                                <Col sm="6" className="text-end">
                                    {/* {!isEditable ? (
                                        <Button variant="outline-primary" size="sm" onClick={() => setIsEditable(true)}> Edit </Button>
                                    ) : (
                                        <Button variant="primary" size="sm" onClick={() => { saveSettings(); }}>Save</Button>
                                    )} */}
                                </Col>
                            </Row>
                        </div>
                        <div className="uld_notification_body">

                            {shiftData?.map((shft, index) => (
                                <div sm="12" className="d-flex justify-content-between w-100 mt-2" key={'shft_' + index}>
                                    <div className='d-flex align-items-center'>
                                        {shft.button !== 'Add' &&
                                            <>
                                                <input
                                                    type='time'
                                                    className="form-control me-2 tw-44"
                                                    value={shft.start_time}
                                                    onChange={(e) => shiftChange(index, 'start_time', e.target.value)}
                                                    disabled={isEditable !== index}
                                                />
                                                <span>to</span>
                                                <input
                                                    type='time'
                                                    className="form-control ms-2 tw-44"
                                                    value={shft.end_time}
                                                    onChange={(e) => shiftChange(index, 'end_time', e.target.value)}
                                                    disabled={isEditable !== index}
                                                />
                                            </>
                                        }
                                    </div>
                                    <div>
                                        <Button onClick={() => addEditShift(shft, index)} variant={ shft.button !== 'Add' ? 'contained' : 'primary'}>
                                            {shft.button === 'Edit' ? <Edit_icon /> : shft.button === 'Save' ? <Save_icon /> : shft.button}
                                        </Button>

                                        {shft.button !== 'Add' && <Button  variant='contained' onClick={() => removeShift(shft, index)}> <Trash/> </Button>}
                                    </div>
                                </div>
                            ))}

                            {/* <div sm="12" className="d-flex align-items-center w-100 mt-2">
                                <input
                                    type='time'
                                    className="form-control me-2 tw-25"
                                    value='06:00'
                                    disabled={!isEditable} />
                                <span>to</span>
                                <input
                                    type='time'
                                    className="form-control ms-2 tw-25"
                                    value='14:00'
                                    disabled={!isEditable} />
                            </div>

                            <div sm="12" className="d-flex align-items-center w-100 mt-2">
                                <input
                                    type='time'
                                    className="form-control me-2 tw-25"
                                    value='14:00'
                                    disabled={!isEditable} />
                                <span>to</span>
                                <input
                                    type='time'
                                    className="form-control ms-2 tw-25"
                                    value='23:00'
                                    disabled={!isEditable} />
                            </div>
                            <div sm="12" className="d-flex align-items-center w-100 mt-2">
                                <input
                                    type='time'
                                    className="form-control me-2 tw-25"
                                    value='23:00'
                                    disabled={!isEditable} />
                                <span>to</span>
                                <input
                                    type='time'
                                    className="form-control ms-2 tw-25"
                                    value='06:00'
                                    disabled={!isEditable} />
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default General